module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Bold.29d863eb.eot";